var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _ellipse, _ellipse2, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_go") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.987,17.15c.04.826.865.444,1.239.186.355-.245.459-.041.49-.525a7.937,7.937,0,0,0,.039-.955,2.342,2.342,0,0,0-1.56.4c-.227.165-.651.69-.208.9",
    style: {
      fill: "#f6d2a2",
      fillRule: "evenodd"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.416,17.732a.527.527,0,0,1-.236-.051.541.541,0,0,1-.27-.482.358.358,0,0,1-.2-.283,1.006,1.006,0,0,1,.432-.727,2.4,2.4,0,0,1,1.613-.413l.068.006,0,.068a5.667,5.667,0,0,1-.023.747c-.006.073-.011.145-.016.218-.022.343-.086.395-.263.456a.975.975,0,0,0-.261.129A1.788,1.788,0,0,1,6.416,17.732Zm1.11-1.808a2.2,2.2,0,0,0-1.286.394c-.162.118-.387.394-.368.584a.219.219,0,0,0,.147.177l.043.02,0,.047c.01.206.072.338.185.394.218.108.624-.058.931-.269a1.127,1.127,0,0,1,.3-.148c.116-.04.14-.049.157-.318,0-.073.01-.146.016-.22a6.148,6.148,0,0,0,.026-.658Q7.6,15.924,7.527,15.924Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.987,17.15a.65.65,0,0,0,.329-.185",
    style: {
      fill: "#c6b198",
      fillRule: "evenodd"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.987,17.229a.079.079,0,0,1-.027-.152l.053-.019a.473.473,0,0,0,.241-.139.079.079,0,1,1,.126.094.615.615,0,0,1-.314.193l-.051.018A.078.078,0,0,1,5.987,17.229Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.894,7.309C4.731,6.42,7.083,2.4,9.622,4.052Z",
    style: {
      fill: "#6ad7e5",
      fillRule: "evenodd"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.934,7.4l-.061-.017a1.927,1.927,0,0,1-1.562-1.5,2.094,2.094,0,0,1,.977-1.979,2.116,2.116,0,0,1,2.378.081l.06.039Zm.449-3.666a1.852,1.852,0,0,0-1.01.3,1.933,1.933,0,0,0-.907,1.823A1.755,1.755,0,0,0,7.854,7.216L9.519,4.079A2.17,2.17,0,0,0,8.383,3.736Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.944,3.75c2.5-1.758,4.765,2.209,1.856,3.207Z",
    style: {
      fill: "#6ad7e5",
      fillRule: "evenodd"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.765,7.052,21.84,3.727l.059-.041a2.066,2.066,0,0,1,2.295-.193,2.122,2.122,0,0,1,1.044,1.965,1.881,1.881,0,0,1-1.413,1.573ZM22.049,3.773,23.836,6.86a1.712,1.712,0,0,0,1.246-1.418,1.961,1.961,0,0,0-.967-1.814A1.857,1.857,0,0,0,22.049,3.773Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.483,27.317c.636.393,1.8,1.583.844,2.16-.916.839-1.429-.921-2.234-1.165A2.225,2.225,0,0,1,22.483,27.317Z",
    style: {
      fill: "#f6d2a2",
      fillRule: "evenodd"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.844,29.781h-.038c-.361-.022-.661-.374-.951-.715a2.041,2.041,0,0,0-.785-.677l-.106-.032.066-.09a2.323,2.323,0,0,1,1.441-1.026l.029,0,.025.015c.407.252,1.247.988,1.243,1.654a.73.73,0,0,1-.393.636A.791.791,0,0,1,22.844,29.781Zm-1.625-1.5a2.505,2.505,0,0,1,.756.687c.281.33.547.642.841.66a.626.626,0,0,0,.457-.2l.012-.009a.578.578,0,0,0,.324-.506c0-.532-.672-1.2-1.144-1.5A2.055,2.055,0,0,0,21.219,28.276Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.327,29.556a.079.079,0,0,1-.07-.043,2.918,2.918,0,0,1-.123-.3,1.309,1.309,0,0,0-.286-.518.079.079,0,0,1,.109-.113,1.447,1.447,0,0,1,.325.577,2.806,2.806,0,0,0,.116.28.079.079,0,0,1-.035.106A.078.078,0,0,1,23.327,29.556Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.124,28.662c-.746.115-1.166.789-1.788,1.131-.586.35-.811-.112-.863-.206-.092-.042-.084.039-.226-.1C7.7,28.625,8.812,28,9.39,27.572,10.195,27.409,10.7,28.107,11.124,28.662Z",
    style: {
      fill: "#f6d2a2",
      fillRule: "evenodd"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.939,30a.535.535,0,0,1-.141-.018.647.647,0,0,1-.38-.33H8.4c-.066,0-.115-.014-.213-.113l-.011-.013c-.523-.826.367-1.453.957-1.868.074-.052.144-.1.207-.148l.014-.01.017,0c.829-.168,1.353.518,1.773,1.069l.119.155-.131.02a2.263,2.263,0,0,0-1.105.634,4.023,4.023,0,0,1-.657.488A.859.859,0,0,1,8.939,30Zm-.527-.506a.213.213,0,0,1,.092.021l.023.011.02.035a.509.509,0,0,0,.292.269.6.6,0,0,0,.456-.1,3.909,3.909,0,0,0,.633-.471,2.629,2.629,0,0,1,1.056-.644c-.4-.526-.862-1.094-1.562-.963-.061.044-.127.091-.2.139-.6.424-1.352.952-.919,1.648.062.062.077.061.09.061Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.472,29.665H8.465a.079.079,0,0,1-.072-.085,1.2,1.2,0,0,1,.253-.572,1.852,1.852,0,0,0,.165-.276.079.079,0,0,1,.144.064,1.992,1.992,0,0,1-.178.3,1.065,1.065,0,0,0-.226.5A.079.079,0,0,1,8.472,29.665Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.026,6.2c-.417-.221-.723-.52-.468-1,.236-.447.675-.4,1.092-.178Z",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.141,5.778c.417-.221.723-.52.468-1-.236-.447-.675-.4-1.092-.178Z",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.013,17.046c-.04.826-.865.444-1.239.186-.355-.245-.459-.041-.49-.525a7.936,7.936,0,0,1-.039-.955,2.342,2.342,0,0,1,1.56.4c.227.165.651.69.208.9",
    style: {
      fill: "#f6d2a2",
      fillRule: "evenodd"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.584,17.627a1.788,1.788,0,0,1-.854-.331.975.975,0,0,0-.261-.129c-.177-.062-.241-.114-.263-.456,0-.073-.01-.145-.016-.218a5.676,5.676,0,0,1-.023-.747l0-.068.068-.006a2.4,2.4,0,0,1,1.613.413,1.006,1.006,0,0,1,.432.727.358.358,0,0,1-.2.283.541.541,0,0,1-.27.482A.527.527,0,0,1,25.584,17.627Zm-1.263-1.8a6.148,6.148,0,0,0,.026.658c.006.073.011.146.016.22.017.269.041.277.157.318a1.127,1.127,0,0,1,.3.148c.306.212.713.377.931.269.113-.056.175-.188.185-.394l0-.047.043-.02a.219.219,0,0,0,.147-.177c.018-.19-.206-.466-.368-.584A2.232,2.232,0,0,0,24.321,15.824Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.013,17.046a.65.65,0,0,1-.329-.185",
    style: {
      fill: "#c6b198",
      fillRule: "evenodd"
    }
  }), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M26.013,17.124a.078.078,0,0,1-.027,0l-.051-.018a.614.614,0,0,1-.314-.193.079.079,0,1,1,.126-.094.473.473,0,0,0,.241.139l.053.019a.079.079,0,0,1-.027.152Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.683,2.079c3.166,0,6.134.453,7.681,3.495,1.389,3.409.895,7.086,1.107,10.689.182,3.094.585,6.668-.85,9.536-1.51,3.016-5.283,3.775-8.392,3.664-2.442-.087-5.391-.884-6.769-3.115-1.617-2.617-.851-6.509-.734-9.421.139-3.449-.934-6.91.2-10.285,1.176-3.5,4.346-4.293,7.758-4.563",
    style: {
      fill: "#6ad7e5",
      fillRule: "evenodd"
    }
  }), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M15.77,29.55c-.2,0-.38,0-.543-.01-1.5-.054-5.176-.469-6.833-3.152-1.307-2.116-1.074-5.041-.869-7.622.052-.649.1-1.263.124-1.843a29.673,29.673,0,0,0-.157-3.666,16.216,16.216,0,0,1,.36-6.641,5.812,5.812,0,0,1,3.08-3.539A12.948,12.948,0,0,1,15.677,2h.006c3.091,0,6.17.429,7.751,3.538l0,.006a20.518,20.518,0,0,1,1.044,7.762c.005.969.011,1.972.068,2.952.017.3.037.6.057.9.184,2.841.392,6.062-.915,8.673C22.059,29.092,17.947,29.55,15.77,29.55ZM15.686,2.157c-3.294.261-6.5.988-7.687,4.509a16.1,16.1,0,0,0-.353,6.578A29.788,29.788,0,0,1,7.8,16.93c-.024.584-.072,1.2-.124,1.85-.2,2.557-.434,5.455.846,7.527,1.618,2.619,5.228,3.025,6.705,3.077,1.922.069,6.579-.147,8.318-3.621,1.288-2.573,1.081-5.771.9-8.592-.02-.3-.039-.606-.057-.9-.058-.984-.063-1.989-.068-2.96a20.408,20.408,0,0,0-1.031-7.7C21.75,2.576,18.725,2.158,15.686,2.157Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.242,6.329c.568,3.3,5.97,2.431,5.194-.9-.7-2.988-5.383-2.161-5.194.9",
    style: {
      fill: "#ffffff",
      fillRule: "evenodd"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.808,8.485a3.025,3.025,0,0,1-.988-.162,2.444,2.444,0,0,1-1.653-1.982V6.333a2.672,2.672,0,0,1,2.416-2.814A2.482,2.482,0,0,1,21.51,5.41a2.312,2.312,0,0,1-.673,2.343A3.072,3.072,0,0,1,18.808,8.485ZM16.318,6.32A2.3,2.3,0,0,0,17.87,8.18a2.987,2.987,0,0,0,2.865-.54,2.165,2.165,0,0,0,.627-2.2A2.335,2.335,0,0,0,18.6,3.67,2.524,2.524,0,0,0,16.318,6.32Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.788,6.863C10.524,9.74,15.13,9,14.956,6.118c-.208-3.456-5.873-2.789-5.169.745",
    style: {
      fill: "#ffffff",
      fillRule: "evenodd"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.245,8.761A2.826,2.826,0,0,1,10.9,8.435,2.384,2.384,0,0,1,9.716,6.882v0a2.411,2.411,0,0,1,.826-2.472,3.107,3.107,0,0,1,3.087-.394,2.335,2.335,0,0,1,1.4,2.1,2.529,2.529,0,0,1-2.29,2.609A3.2,3.2,0,0,1,12.245,8.761ZM9.86,6.847a2.4,2.4,0,0,0,2.858,1.729,2.385,2.385,0,0,0,2.165-2.454,2.193,2.193,0,0,0-1.314-1.976,2.953,2.953,0,0,0-2.935.374A2.269,2.269,0,0,0,9.86,6.847Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.894,10.294a7.45,7.45,0,0,1,.016,1.369c-.11.207-.325.229-.51.313a.751.751,0,0,1-.575-.449,9.72,9.72,0,0,1,.041-1.549Z",
    style: {
      fill: "#ffffff",
      fillRule: "evenodd"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.411,12.057l-.023,0a.828.828,0,0,1-.635-.5l0-.01v-.011a5.2,5.2,0,0,1,.009-1.063c.013-.163.026-.331.031-.5l0-.1,1.181.362v.058c0,.142.012.289.024.444a3.746,3.746,0,0,1-.008.939l0,.012-.006.011a.658.658,0,0,1-.414.3c-.047.017-.091.032-.134.052Zm-.509-.551a.671.671,0,0,0,.488.388c.041-.017.083-.032.123-.047a.525.525,0,0,0,.322-.211,3.683,3.683,0,0,0,0-.887c-.01-.137-.02-.268-.023-.4l-.875-.268c-.007.136-.017.271-.027.4A5.05,5.05,0,0,0,15.9,11.506Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.058,
    cy: 6.394,
    rx: 0.778,
    ry: 0.842
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.412,
    cy: 6.584,
    rx: 0.183,
    ry: 0.214,
    style: {
      fill: "#fff"
    }
  }), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.574,
    cy: 6.184,
    rx: 0.765,
    ry: 0.842
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.922,
    cy: 6.374,
    rx: 0.18,
    ry: 0.214,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.671,10.247c-.339.822.189,2.467,1.11,1.254a9.72,9.72,0,0,1,.041-1.549Z",
    style: {
      fill: "#ffffff",
      fillRule: "evenodd"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.166,12.013a.451.451,0,0,1-.226-.062,1.6,1.6,0,0,1-.341-1.733l.015-.036L15.9,9.85l0,.1c-.005.17-.019.34-.032.5a5,5,0,0,0-.01,1.031l0,.032-.019.026C15.574,11.9,15.345,12.013,15.166,12.013Zm-.436-1.7a1.458,1.458,0,0,0,.288,1.5c.238.136.5-.1.681-.335a5.349,5.349,0,0,1,.013-1.031c.01-.129.02-.261.027-.392Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.787,8.663a1,1,0,0,0-.821,1.4c.435.788,1.407-.07,2.013.011.7.014,1.268.737,1.827.131.622-.674-.268-1.331-.964-1.624Z",
    style: {
      fill: "#f6d2a2",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.308,10.526a1.727,1.727,0,0,1-.641-.179,1.928,1.928,0,0,0-.689-.194h-.009a1.749,1.749,0,0,0-.712.152c-.491.17-1.048.362-1.36-.2a.946.946,0,0,1,.014-.917,1.118,1.118,0,0,1,.869-.6h0L16.857,8.5l.016.007c.517.218,1.106.617,1.207,1.083a.836.836,0,0,1-.772.934ZM15.985,10a2.056,2.056,0,0,1,.743.206c.393.165.7.295,1.021-.05a.58.58,0,0,0,.178-.528c-.087-.4-.642-.769-1.1-.964l-2.036.081a.973.973,0,0,0-.742.517.792.792,0,0,0-.015.767c.248.449.7.294,1.17.13A1.856,1.856,0,0,1,15.985,10Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.708,8.63C14.661,7.535,16.75,7.4,17,8.315s-2.186,1.128-2.289.316Z",
    style: {
      fillRule: "evenodd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.17998c2f7758f5b1498dacaf92caf9fc.svg";
export { ForwardRef as ReactComponent };